import { getStore } from '../store/store';
import CalendarItem from 'owa-service/lib/contract/CalendarItem';
import { FIVE_MINUTES_IN_MILLISECONDS } from '../utils/UpNextConstants';

export default function getNextMeeting(): CalendarItem {
    let nextMeeting: CalendarItem;
    const meetings = getStore().calendarItems.values();
    const fiveMinutesAgo = getFiveMinutesAgoDate();

    for (const meeting of meetings) {
        if (
            new Date(meeting.Start) > fiveMinutesAgo &&
            (!nextMeeting || (nextMeeting && new Date(meeting.Start) < new Date(nextMeeting.Start)))
        ) {
            // We found the next meeting.
            nextMeeting = meeting;
        }
    }
    return nextMeeting;
}

function getFiveMinutesAgoDate(): Date {
    const fiveMinutesAgo = new Date();
    fiveMinutesAgo.setTime(fiveMinutesAgo.getTime() - FIVE_MINUTES_IN_MILLISECONDS);
    return fiveMinutesAgo;
}
